// Brand-consistent media URLs
export const MEDIA = {
  // Hero photo (from official Sprouts brochure — students at Kennedy Space Center)
  hero: "/brochure/hero-students-nasa.jpg",
};

export const REGIONS = [
  "Telangana",
  "Andhra Pradesh",
  "Tamil Nadu",
  "Karnataka",
  "Maharashtra",
  "Delhi NCR",
  "Chandigarh & Tricity",
];

// School registrations deadline used by countdown
export const SUBMISSION_DEADLINE = new Date("2026-07-31T23:59:59+05:30");
